import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const applicationId = import.meta.env.VITE_DD_APPLICATION_ID;
const clientToken = import.meta.env.VITE_DD_CLIENT_TOKEN;
const env = import.meta.env.MODE;

if (applicationId && clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.eu',
    service: 'xcover-shell',
    env,
    sessionSampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    enablePrivacyForActionName: true,
    sessionReplaySampleRate: env === 'staging' ? 100 : 5,
    traceSampleRate: env === 'staging' ? 100 : 5,
    traceContextInjection: 'sampled',
    // Exclude both brightwrite.com and brightwrite-data.com anywhere in the full URL
    excludedActivityUrls: [/brightwrite(-data)?\.com/i],
    plugins: [reactPlugin({ router: false })],
  });
}
